import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Canada, eh?",
  "description": "",
  "published": "2013-04-09T00:00:00.000Z",
  "redirect_from": ["/blog/canada-eh/swizec/6102"],
  "categories": "Bytown, Canada, Ljubljana, Ottawa, Quebec, Travel + Events",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Job interviews are fast becoming a bit of a hobby for me. Usually just over Skype and for a shortish-term freelancing gig. Sometimes in person for a job job.`}</p>
    <p>{`Last week I went to `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=45.4,-75.6666666667&spn=10.0,10.0&q=45.4,-75.6666666667%20(Canada)&t=h",
        "title": "Canada"
      }}>{`Canada`}</a>{` to interview with `}<a parentName="p" {...{
        "href": "http://shopify.com",
        "title": "Shopify"
      }}>{`Shopify`}</a>{`. This post is about the traveling bit, next post will be about the interview bit. Without revealing too much too soon, I can say it was one of the best interviewing experiences ever.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/04/canada-parliament.jpg",
        "alt": "Canadian parliament",
        "title": "Canadian parliament"
      }}></img></p>
    <h2 {...{
      "id": "traveling-to-canada"
    }}>{`Traveling to Canada`}</h2>
    <p>{`Canadians do say `}<em parentName="p">{`"aboot"`}</em>{`, they also say `}{`_`}{`"eh". `}{`_`}{`But they say eh so much and so often I was unable to figure out what it actually means. It's not always a question, sometimes it's more of a "yes, what I am saying did actually happen literally". It's a confusing little word.`}</p>
    <p>{`Canadians are also just as nice as I expected watching american television. The `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/French_Canadian",
        "title": "French Canadian"
      }}>{`French Canadians`}</a>{` are just as nice and friendly as people were in France ... which is to say surprisingly little. Luckily I didn't spend a lot of time in the french parts of Canada. I did take a walk to `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=46.8161111111,-71.2241666667&spn=0.1,0.1&q=46.8161111111,-71.2241666667%20(Quebec)&t=h",
        "title": "Quebec"
      }}>{`Quebec`}</a>{` though, just to go see the cool Museum of Civilizations.`}</p>
    <p>{`On Tuesday morning I awoke to a miserably cold and windy `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=45.4208333333,-75.69&spn=0.1,0.1&q=45.4208333333,-75.69%20(Ottawa)&t=h",
        "title": "Ottawa"
      }}>{`Ottawa`}</a>{`. Other than the buildings and the odd car here and there Ottawa, the city of one million, looked like a ghost town. I met about one person every five minutes, despite being in the part of town crowded by bars and pubs.`}</p>
    <p>{`It wasn't too cold, just -6 really, but my jeans was nothing against the wind. Like I was walking around half naked ... thank god for the giant scarf I got from mum for Christmas.`}</p>
    <p>{`Apparently I visited Ottawa at a rather awkward time. It wasn't winter and it wasn't spring.`}</p>
    <p>{`In winter they have a bunch of stuff going on at the frozen Rideau canal. Turns into a 7 kilometer skating rink! In spring, there's a bunch of stuff going on at the `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=45.42451,-75.694817&spn=1.0,1.0&q=45.42451,-75.694817%20(Bytown)&t=h",
        "title": "Bytown"
      }}>{`Bytown`}</a>{` market - daily farmer's market stuff, plenty of events, even a busker's festival!`}</p>
    <p>{`Last week ... nothing. Completely dead.`}</p>
    <p>{`Weather turned for the better on Thursday and while still a chilly ~3C it was very sunny and the whole city came alive. Their one pedestrian street was full of people and walking around was an absolute pleasure. Suddenly I could see myself living here. It was no European town like I'm used to, but it was `}<em parentName="p">{`alive`}</em>{`. A proper city!`}</p>
    <p>{`Despite its huge surface area (100x100 km I'm told) and a population about thrice that of `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=46.0555555556,14.5083333333&spn=0.1,0.1&q=46.0555555556,14.5083333333%20(Ljubljana)&t=h",
        "title": "Ljubljana"
      }}>{`Ljubljana`}</a>{`, Ottawa feels a lot like Ljubljana really. Minus the ~100,000 students and put on a classic North American grid system ... and younger, much much younger. The oldest parts of Ottawa still standing are from the early 1800's. Just enough to give the city a bit of a flare, a touch of history.`}</p>
    <p>{`Strange feeling that, a huge city that's less crowded than my tiny "city". Their museums were awesome though, at least the two I visited. Museum of Civilizations talking about how Canada evolved from the old peoples to the modern mix of people from France, British loyalists and all the old native peoples. Really loved the huge displays where you basically walk around a colonial town at 1:1 scale, then turn a corner and suddenly it's a town in the 19th century.`}</p>
    <p>{`The War Museum had a similar design going where you walk from the early native peoples wars all the way to modern peace keeping stuff, but such museums are usually dark and don't take pretty pictures, plus they all look alike. There was an awesome assortment of tanks and artillery though. Even a jet fighter!`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/04/bear-statue.jpg",
        "alt": "At the only pedestrian street, there was a bear statue",
        "title": "At the only pedestrian street, there was a bear statue"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/04/confluence-of-rivers.jpg",
        "alt": "There's a huge confluence of rivers right on the border of Quebec and Ontario",
        "title": "There's a huge confluence of rivers right on the border of Quebec and Ontario"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/04/totems.jpg",
        "alt": "Museum of Civilizations reveals that totems are _huge_",
        "title": "Museum of Civilizations reveals that totems are _huge_"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/04/museum-of-civilizations.jpg",
        "alt": "There's also exhibitions built up as old towns",
        "title": "There's also exhibitions built up as old towns"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/04/voodoo.jpg",
        "alt": "Voodoo exhibition with real human skulls",
        "title": "Voodoo exhibition with real human skulls"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/04/jetfighter.jpg",
        "alt": "On Thursday I went to the War Museum where there was a jetfighter",
        "title": "On Thursday I went to the War Museum where there was a jetfighter"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/04/victory-bonds.jpg",
        "alt": "Most displays were too dark to take pics",
        "title": "Most displays were too dark to take pics"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/04/housey1.jpg",
        "alt": "On my way back I found a cute housey",
        "title": "On my way back I found a cute housey"
      }}></img></p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=1b5ae7ff-277d-4a1b-bf54-be09bfdf7dd8",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      